import "./web-component";
import "./styles/globals.css";

// Étendre l'interface Window pour les propriétés personnalisées
declare global {
  interface Window {
    MonTrackeurInit: () => void;
    wp?: any;
  }
}

const renderApp = () => {
  let popupElement = document.querySelector("read2earn-popup");
  if (!popupElement) {
    popupElement = document.createElement("read2earn-popup");
    document.body.appendChild(popupElement);
  }
};

const initApp = () => {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", renderApp);
  } else {
    renderApp();
  }
};

// Assurer la compatibilité avec WordPress en utilisant une fonction globale
window.MonTrackeurInit = initApp;

// Auto-init si pas dans WordPress
if (!window.wp) {
  initApp();
}
